import _toConsumableArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
var __jsx = React.createElement;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import React, { useState, useCallback, useMemo } from "react";
import Modal from "../../common/Modal";
import classNames from "classnames";
import Toast from "../../Toast";
import Store from "../../../utils/Store";
import ConfirmationModal from "../../ConfirmationModal";
import useGetPatientReports from "../services/useGetPatientReports";
import useCreateSubmission from "../services/useCreateSubmission";
import useDeleteSubmission from "../services/useDeleteSubmission";
import ReportCard from "./ReportCard";
import Loader from "../../Loader";
import { SUBMISSION_STATUS, ACR_STATUS } from "../../../constants/acr";
import { useTranslation } from "react-i18next";
var TABS = {
  ALL: {
    id: "all",
    title: "All"
  },
  PENDING: {
    id: SUBMISSION_STATUS.PENDING,
    title: "Pending / Rejected"
  },
  SUBMITTED: {
    id: SUBMISSION_STATUS.SUBMITTED,
    title: "Submitted"
  },
  ACCEPTED: {
    id: SUBMISSION_STATUS.ACCEPTED,
    title: "Accepted"
  }
};
var AllACRSubmissions = function AllACRSubmissions(_ref) {
  var _tabs$find;
  var isOpen = _ref.isOpen,
    setIsAllSubmissionModalOpen = _ref.setIsAllSubmissionModalOpen,
    onSubmissionViewDetails = _ref.onSubmissionViewDetails,
    workspaceId = _ref.workspaceId,
    patientId = _ref.patientId,
    activeTab = _ref.activeTab,
    setActiveTab = _ref.setActiveTab;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useGetPatientReports = useGetPatientReports({
      workspaceId: workspaceId,
      patientId: patientId,
      enabled: isOpen
    }),
    data = _useGetPatientReports.data,
    isLoading = _useGetPatientReports.isLoading;
  var reports = (data === null || data === void 0 ? void 0 : data.results) || [];
  var createMutation = useCreateSubmission();
  var deleteMutation = useDeleteSubmission();
  var _useState = useState(null),
    pendingAction = _useState[0],
    setPendingAction = _useState[1];
  var openConfirmation = useCallback(function (action) {
    setPendingAction(action);
    Store.update(function (s) {
      s.isConfirmationModalOpen = true;
    });
  }, []);
  var closeConfirmation = useCallback(function () {
    setPendingAction(null);
    Store.update(function (s) {
      s.isConfirmationModalOpen = false;
    });
  }, []);
  var handleModalClose = function handleModalClose() {
    setIsAllSubmissionModalOpen(false);
  };
  var handleConfirm = useCallback(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var _error$response, _error$response2, _error$response3, _t, _t2;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          if (pendingAction) {
            _context.n = 1;
            break;
          }
          return _context.a(2);
        case 1:
          if (!(pendingAction.type === "create")) {
            _context.n = 6;
            break;
          }
          _context.p = 2;
          _context.n = 3;
          return createMutation.mutateAsync({
            workspaceId: workspaceId,
            reportId: pendingAction.reportId,
            patientId: patientId
          });
        case 3:
          Toast.success(t("toast.submission_created_successfully"));
          _context.n = 5;
          break;
        case 4:
          _context.p = 4;
          _t = _context.v;
          if ((_t === null || _t === void 0 || (_error$response = _t.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 409) {
            Toast.success(t("toast.submission_already_exists_for_report"));
          } else {
            Toast.error((_t === null || _t === void 0 || (_error$response2 = _t.response) === null || _error$response2 === void 0 || (_error$response2 = _error$response2.data) === null || _error$response2 === void 0 ? void 0 : _error$response2.detail) || t("toast.failed_to_create_submission"));
          }
        case 5:
          _context.n = 10;
          break;
        case 6:
          if (!(pendingAction.type === "delete")) {
            _context.n = 10;
            break;
          }
          _context.p = 7;
          _context.n = 8;
          return deleteMutation.mutateAsync({
            submissionId: pendingAction.submissionId,
            workspaceId: workspaceId
          });
        case 8:
          Toast.success(t("toast.submission_deleted_successfully"));
          _context.n = 10;
          break;
        case 9:
          _context.p = 9;
          _t2 = _context.v;
          Toast.error((_t2 === null || _t2 === void 0 || (_error$response3 = _t2.response) === null || _error$response3 === void 0 || (_error$response3 = _error$response3.data) === null || _error$response3 === void 0 ? void 0 : _error$response3.detail) || t("toast.failed_to_delete_submission"));
        case 10:
          closeConfirmation();
        case 11:
          return _context.a(2);
      }
    }, _callee, null, [[7, 9], [2, 4]]);
  })), [pendingAction, workspaceId, patientId, createMutation, deleteMutation, closeConfirmation]);

  // Sort: reports with submissions first, without submissions at bottom
  var sortedReports = _toConsumableArray(reports).sort(function (a, b) {
    if (a.acr_submission && !b.acr_submission) return -1;
    if (!a.acr_submission && b.acr_submission) return 1;
    return 0;
  });

  // Helper function to determine which tab a report belongs to based on status bucketing rules
  var getReportTab = function getReportTab(report) {
    if (!report.acr_submission) return "none";
    var _report$acr_submissio = report.acr_submission,
      acr_status = _report$acr_submissio.acr_status,
      status = _report$acr_submissio.status;

    // Priority to acr_status if present
    if (acr_status) {
      // ACR status bucketing
      var pendingACRStatuses = [ACR_STATUS.PARTIALLY_SUCCESSFUL, ACR_STATUS.VALIDATION_FAIL, ACR_STATUS.FAILED];
      var submittedACRStatuses = [ACR_STATUS.ENQUEUED, ACR_STATUS.LOADING, ACR_STATUS.RECEIVED, ACR_STATUS.POSTED];
      var acceptedACRStatuses = [ACR_STATUS.ACCEPTED, ACR_STATUS.VALIDATION_SUCCESSFUL];
      if (submittedACRStatuses.includes(acr_status)) {
        return SUBMISSION_STATUS.SUBMITTED;
      }
      if (acceptedACRStatuses.includes(acr_status)) {
        return SUBMISSION_STATUS.ACCEPTED;
      }
      if (pendingACRStatuses.includes(acr_status)) {
        return SUBMISSION_STATUS.PENDING;
      }
    }

    // Fall back to internal status
    var internalStatus = status.toLowerCase();
    var pendingInternalStatuses = [SUBMISSION_STATUS.PENDING, SUBMISSION_STATUS.READY, SUBMISSION_STATUS.SUBMITTING, SUBMISSION_STATUS.VALIDATION_FAILED, SUBMISSION_STATUS.PARTIALLY_SUCCESSFUL, SUBMISSION_STATUS.ERROR, SUBMISSION_STATUS.REJECTED, SUBMISSION_STATUS.FAILED];
    if (pendingInternalStatuses.includes(internalStatus)) {
      return SUBMISSION_STATUS.PENDING;
    }
    if (internalStatus === SUBMISSION_STATUS.SUBMITTED) {
      return SUBMISSION_STATUS.SUBMITTED;
    }
    if (internalStatus === SUBMISSION_STATUS.ACCEPTED) {
      return SUBMISSION_STATUS.ACCEPTED;
    }
    return internalStatus;
  };
  var filterReports = function filterReports(tabId) {
    if (tabId === TABS.ALL.id) return sortedReports;
    return sortedReports.filter(function (r) {
      if (!r.acr_submission) return false;
      return getReportTab(r) === tabId;
    });
  };
  var tabs = [{
    id: TABS.ALL.id,
    name: TABS.ALL.title,
    count: reports.length
  }, {
    id: TABS.PENDING.id,
    name: TABS.PENDING.title,
    count: filterReports(TABS.PENDING.id).length
  }, {
    id: TABS.SUBMITTED.id,
    name: TABS.SUBMITTED.title,
    count: filterReports(TABS.SUBMITTED.id).length
  }, {
    id: TABS.ACCEPTED.id,
    name: TABS.ACCEPTED.title,
    count: filterReports(TABS.ACCEPTED.id).length
  }];
  var filteredReports = useMemo(function () {
    return filterReports(activeTab);
  }, [activeTab, sortedReports]);
  var accessionDisplay = (pendingAction === null || pendingAction === void 0 ? void 0 : pendingAction.accessionNumber) || "N/A";
  var confirmLabels = (pendingAction === null || pendingAction === void 0 ? void 0 : pendingAction.type) === "delete" ? {
    title: t("label.acr.delete_submission"),
    label: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "mb-2"
    }, /*#__PURE__*/React.createElement("span", {
      className: "font-bold"
    }, t("accession_number"), ": "), /*#__PURE__*/React.createElement("span", {
      className: "text-gray-600 dark:text-gray-400"
    }, accessionDisplay)), /*#__PURE__*/React.createElement("div", null, t("label.acr.delete_submission_confirmation"))),
    yes: t("delete"),
    no: t("cancel")
  } : {
    title: t("label.acr.create_submission"),
    label: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "mb-2"
    }, /*#__PURE__*/React.createElement("span", {
      className: "font-bold"
    }, t("accession_number"), ": "), /*#__PURE__*/React.createElement("span", {
      className: "text-gray-600 dark:text-gray-400"
    }, accessionDisplay)), /*#__PURE__*/React.createElement("div", null, t("label.acr.create_submission_confirmation"), " ")),
    yes: t("create"),
    no: t("cancel")
  };
  var activeTabName = ((_tabs$find = tabs.find(function (t) {
    return t.id === activeTab;
  })) === null || _tabs$find === void 0 ? void 0 : _tabs$find.name) || "";
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal, {
    show: isOpen,
    onClose: handleModalClose,
    title: /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col items-start text-left"
    }, /*#__PURE__*/React.createElement("div", null, t("label.acr.all_exams_title")), /*#__PURE__*/React.createElement("div", {
      className: "text-base font-normal"
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-gray-700 dark:text-gray-300"
    }, patientId), function (_reports$find) {
      var patientName = (_reports$find = reports.find(function (r) {
        var _r$acr_submission;
        return (_r$acr_submission = r.acr_submission) === null || _r$acr_submission === void 0 ? void 0 : _r$acr_submission.patient_name;
      })) === null || _reports$find === void 0 || (_reports$find = _reports$find.acr_submission) === null || _reports$find === void 0 ? void 0 : _reports$find.patient_name;
      return patientName ? /*#__PURE__*/React.createElement("span", {
        className: "text-gray-600 dark:text-gray-400"
      }, " / ", patientName) : null;
    }())),
    className: "w-full sm:w-11/12 md:w-9/12 lg:w-7/12 xl:w-6/12 h-[80vh] flex flex-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col flex-1 min-h-0 bg-gray-100 dark:bg-gray-900"
  }, isLoading ? /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center flex-1"
  }, /*#__PURE__*/React.createElement(Loader, {
    size: "small"
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "sticky top-0 z-10 bg-gray-100 dark:bg-gray-900 px-5 pt-5 pb-4 flex-shrink-0 border-b border-gray-300 dark:border-gray-700"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-3"
  }, tabs.map(function (tab) {
    return /*#__PURE__*/React.createElement("button", {
      key: tab.id,
      onClick: function onClick() {
        return setActiveTab(tab.id);
      },
      className: classNames("flex items-center gap-2 rounded-full px-5 py-2 text-base font-medium transition-all duration-200 cursor-pointer border whitespace-nowrap shrink-0", activeTab === tab.id ? "bg-teal-400 text-white border-teal-400" : "border-gray-300 dark:border-gray-600 text-gray-600 dark:text-gray-400 hover:border-gray-400 dark:hover:border-gray-400")
    }, tab.name, /*#__PURE__*/React.createElement("span", {
      className: classNames("min-w-[20px] h-5 px-1.5 flex items-center justify-center rounded-full text-sm font-bold", activeTab === tab.id ? "bg-white/80 text-teal-500" : "bg-gray-300 dark:bg-gray-700 text-gray-600 dark:text-gray-300")
    }, tab.count));
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex-1 overflow-auto scrollbar-light dark:scrollbar px-5 pt-4 pb-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 sm:grid-cols-2 gap-3 w-full"
  }, filteredReports.length > 0 ? filteredReports.map(function (report) {
    return /*#__PURE__*/React.createElement(ReportCard, {
      key: report.report_id,
      report: report,
      workspaceId: workspaceId,
      patientId: patientId,
      onViewDetails: onSubmissionViewDetails,
      onCreateSubmission: function onCreateSubmission(reportId) {
        return openConfirmation({
          type: "create",
          reportId: reportId,
          accessionNumber: report.accession_number
        });
      },
      onDeleteSubmission: function onDeleteSubmission(submissionId) {
        return openConfirmation({
          type: "delete",
          submissionId: submissionId,
          accessionNumber: report.accession_number
        });
      },
      isCreating: createMutation.isLoading
    });
  }) : /*#__PURE__*/React.createElement("div", {
    className: "col-span-full flex flex-col items-center justify-center py-16 text-gray-600 dark:text-gray-400 w-full"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-base"
  }, "No ", activeTab === TABS.ALL.id ? "" : activeTabName.toLowerCase(), " ", "reports"))))))), /*#__PURE__*/React.createElement(ConfirmationModal, {
    onClose: closeConfirmation,
    onClickConfirm: handleConfirm,
    labels: confirmLabels,
    isLoading: createMutation.isLoading || deleteMutation.isLoading
  }));
};
export default AllACRSubmissions;